import { ORDER_STATUSES } from '@wf/shared'

// Board-Beschriftung wie in der Alt-App (länger als die Karten-Badge: „Wartet auf Teil").
const BOARD_LABEL: Record<string, string> = {
  offen: 'Offen',
  arbeit: 'In Arbeit',
  wartet: 'Wartet auf Teil',
  fertig: 'Fertig',
  abgeholt: 'Abgeholt',
}

/** Status-Board: Anzahl Aufträge je Status mit farbigem Punkt (Status-Token) und Zähl-Pille. */
export function StatusBoard({ counts }: { counts: Record<string, number> }) {
  return (
    <div className="wf-ovpanel">
      <h3 className="wf-ovpanel__title">Status-Board</h3>
      <ul className="wf-statusboard">
        {ORDER_STATUSES.map((status) => (
          <li key={status} className="wf-statusboard__row">
            <span className={`wf-statusboard__dot wf-statusboard__dot--${status}`} aria-hidden="true" />
            <span className="wf-statusboard__name">{BOARD_LABEL[status] ?? status}</span>
            <span className={`wf-statusboard__count wf-statusboard__count--${status}`}>{counts[status] ?? 0}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
